export default (id, error) => {
  window.dispatchEvent(
    new CustomEvent('itemDeleteError', { detail: { id, error } })
  );
};
